import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { ISeed } from "../types/seed";

const API = process.env.REACT_APP_API;

const useSeed = () => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["seed"],
    queryFn: () => {
      return fetch(`${API}/api/current-seed`) as Promise<ISeed>;
    },
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useSeed;
